// Constants
// Valuation multiple
const VALUATION_MULTIPLE = window.VALUATION_MULTIPLE || 10
// Marketing & Sales costs (share of MRR)
const MRR_SHARE = window.MRR_SHARE || 0.4
//  Additional Sales & Marketing spend due to Fejron funding
const ADDITIONAL_SPEND = 0.5 || window.ADDITIONAL_SPEND
// Increased sales per EUR spent on Sales and Marketing
const INCREASE_PER_SPEND = window.INCREASE_PER_SPEND || 0.1
//  Fejron funding (share of ARR)
const FEJRON_FUNDING_SHARE = window.FEJRON_FUNDING_SHARE || 0.5
// Expected development in expenses (excl. marketing) (MoM)
const EXPECTED_DEVELOPMENT_IN_EXPENSES =
  window.EXPECTED_DEVELOPMENT_IN_EXPENSES || 0.04
// ?
const FEJRON_FUNDING = window.FEJRON_FUNDING || 0
// Monthly interest rate
const InvestorIRR = window.InvestorIRR || 0.1002
const INTEREST_RATE = (1 + InvestorIRR) ** (1 / 12) - 1
// Initial raise
const INITIAL_RAISE = window.INITIAL_RAISE || 0

const calcGrowthDataset = (
  inputs,
  monthCount = 36,
  onlySales = false,
  extendedRunway = false,
  increasePerSpend = INCREASE_PER_SPEND
) => {
  const { mrr, mom, me, gm, cb } = inputs

  const additionalMarketSpend =
    FEJRON_FUNDING > mrr * MRR_SHARE ? FEJRON_FUNDING - mrr * MRR_SHARE : 0
  const totalCashFlow =
    FEJRON_FUNDING + mrr - me - 0 - additionalMarketSpend + 0

  const availableCcs = mrr * 12 * FEJRON_FUNDING_SHARE
  const additionalCcsVolume =
    0 < 1 && cb + mrr * 12 < 1
      ? Math.min(-totalCashFlow + 0, availableCcs - 0 + 0)
      : 0
  // From start, time = 0
  let dataSet = [
    {
      valuation: mrr * 12 * VALUATION_MULTIPLE,
      month: 0,
      sales: mrr,
      grossProfit: mrr * gm,
      directCosts: mrr - mrr * gm,
      opex: me - mrr * MRR_SHARE - (mrr - mrr * gm),
      marketingSalesCosts: mrr * MRR_SHARE,
      totalExpenses: me,
      cashBalanceWithout: cb,
      mrr: mrr,
      arr: mrr * 12,
      availableCcs,
      fejronFunding: FEJRON_FUNDING,
      issuedCcsVolume: 0,
      shareCcsVolume: 0,
      interestPayment: 0,
      additionalMarketSpend,
      additionalSales: additionalMarketSpend * increasePerSpend,
      accumulatedExtraSales: 0,
      totalCashFlow,
      cashBalanceWith: cb + INITIAL_RAISE,
      additionalCcsVolume,
      accumulatedAdditionalCcs: additionalCcsVolume,
      additionalCcsInterest: 0,
      newTotalCssVolume: additionalCcsVolume + 0,
      newShareCcsVolume: (additionalCcsVolume + 0) / availableCcs,
      newCashBalance: cb + INITIAL_RAISE
    }
  ]
  let monthData = {}
  for (let i = 1; i < monthCount; i++) {
    const prevMonth = dataSet[i - 1]
    monthData = calcMonth(
      inputs,
      prevMonth,
      i,
      onlySales,
      extendedRunway,
      increasePerSpend
    )
    dataSet.push(monthData)
  }
  return dataSet
}

function calcMonth(
  inputs,
  prevMonth,
  i,
  onlySales,
  extendedRunway,
  increasePerSpend
) {
  const { mrr, mom, me, gm, cb } = inputs

  const sales = prevMonth.sales * (1 + mom)
  const grossProfit = sales * gm
  const totalExpenses = prevMonth.totalExpenses * (1 + mom)

  let mrrMonth = prevMonth.mrr * (1 + mom) + prevMonth.additionalSales

  if (i === 1) {
    mrrMonth =
      prevMonth.mrr * (1 + mom) +
      mrr * MRR_SHARE * ADDITIONAL_SPEND * increasePerSpend
  }

  const availableCcs = mrrMonth * 12 * FEJRON_FUNDING_SHARE
  const marketingSalesCosts = sales * MRR_SHARE
  const directCosts = sales - grossProfit
  const fejronFunding = Math.min(
    availableCcs - prevMonth.issuedCcsVolume,
    marketingSalesCosts * (1 + (extendedRunway ? 0 : ADDITIONAL_SPEND))
  )
  const issuedCcsVolume = prevMonth.issuedCcsVolume + fejronFunding
  const additionalMarketSpend = extendedRunway
    ? 0
    : fejronFunding > marketingSalesCosts
    ? fejronFunding - marketingSalesCosts
    : 0

  const interestPayment = issuedCcsVolume * INTEREST_RATE

  const additionalSales = additionalMarketSpend * increasePerSpend
  const accumulatedExtraSales =
    additionalSales + prevMonth.accumulatedExtraSales * (1 + mom)

  const totalCashFlow =
    fejronFunding +
    sales -
    totalExpenses -
    interestPayment -
    additionalMarketSpend +
    accumulatedExtraSales

  const shareCcsVolume = issuedCcsVolume / availableCcs
  const cashBalanceWith = prevMonth.cashBalanceWith + totalCashFlow

  const additionalCcsVolume =
    shareCcsVolume < 1 && cashBalanceWith < 1
      ? Math.min(
          -totalCashFlow + prevMonth.additionalCcsInterest,
          availableCcs - issuedCcsVolume + prevMonth.additionalCcsInterest
        )
      : 0
  const accumulatedAdditionalCcs =
    additionalCcsVolume + prevMonth.accumulatedAdditionalCcs

  const newTotalCssVolume = additionalCcsVolume + issuedCcsVolume

  let monthData = {
    valuation: sales * 12 * VALUATION_MULTIPLE,
    month: i,
    sales,
    grossProfit,
    directCosts,
    opex: totalExpenses - marketingSalesCosts - directCosts,
    marketingSalesCosts,
    totalExpenses,
    cashBalanceWithout: prevMonth.cashBalanceWithout - totalExpenses + sales,
    mrr: mrrMonth,
    arr: mrrMonth * 12,
    availableCcs,
    fejronFunding,
    issuedCcsVolume,
    shareCcsVolume,
    interestPayment,
    additionalMarketSpend,
    additionalSales,
    accumulatedExtraSales,
    totalCashFlow,
    cashBalanceWith,
    additionalCcsVolume,
    accumulatedAdditionalCcs,
    additionalCcsInterest: accumulatedAdditionalCcs * INTEREST_RATE,
    newTotalCssVolume,
    newShareCcsVolume: newTotalCssVolume / availableCcs,
    newCashBalance:
      prevMonth.newCashBalance + totalCashFlow + additionalCcsVolume
  }

  return monthData
}

export { calcGrowthDataset }
